import React from "react";
import FormWrapper from "../../ServeToThrive/shared/FormWrapper";

const choices = [
  {
    value: "serve",
    label: "Serve the church",
    description: "Share your gifts and serve the wider church community with your skills.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M20.84 4.61a5.5 5.5 0 0 0-7.78 0L12 5.67l-1.06-1.06a5.5 5.5 0 0 0-7.78 7.78l1.06 1.06L12 21.23l7.78-7.78 1.06-1.06a5.5 5.5 0 0 0 0-7.78z" />
      </svg>
    ),
  },
  {
    value: "invite",
    label: "Invite gifted people",
    description: "Find and invite gifted people to serve at your congregation or event.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <path d="M17 21v-2a4 4 0 0 0-4-4H5a4 4 0 0 0-4 4v2" />
        <circle cx="9" cy="7" r="4" />
        <path d="M23 21v-2a4 4 0 0 0-3-3.87" />
        <path d="M16 3.13a4 4 0 0 1 0 7.75" />
      </svg>
    ),
  },
  {
    value: "both",
    label: "Both — invite and serve",
    description: "You want to serve the wider church and also invite others to serve with you.",
    icon: (
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
        <circle cx="12" cy="12" r="10" />
        <path d="M12 8v4l3 3" />
      </svg>
    ),
  },
];

export default function WelcomeChoice({ onChoose }) {
  return (
    <FormWrapper>
      <div style={{ textAlign: "center", marginBottom: "36px", animation: "fadeInUp 0.5s ease" }}>
        <div style={{
          width: "56px", height: "56px",
          backgroundColor: "#f3f4f6", borderRadius: "14px",
          display: "flex", alignItems: "center", justifyContent: "center",
          margin: "0 auto 20px", border: "1px solid #e5e7eb",
        }}>
          <svg width="28" height="28" viewBox="0 0 24 24" fill="none" stroke="#36454F" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
            <path d="M3 9l9-7 9 7v11a2 2 0 0 1-2 2H5a2 2 0 0 1-2-2z" />
            <polyline points="9 22 9 12 15 12 15 22" />
          </svg>
        </div>
        <h1 style={{ fontSize: "26px", fontWeight: "700", color: "#1a1a1a", marginBottom: "8px", letterSpacing: "-0.5px" }}>
          Welcome to Collavo
        </h1>
        <p style={{ fontSize: "16px", color: "#737373", margin: 0, lineHeight: "1.5" }}>
          How do you want to use Collavo?
        </p>
      </div>

      <div style={{ display: "flex", flexDirection: "column", gap: "12px", animation: "fadeInUp 0.5s ease 0.1s both" }}>
        {choices.map((choice) => (
          <button
            key={choice.value}
            onClick={() => onChoose(choice.value)}
            style={{
              display: "flex", alignItems: "flex-start", gap: "16px",
              padding: "20px", textAlign: "left",
              backgroundColor: "#fff", border: "1px solid #e5e5e5",
              borderRadius: "10px", cursor: "pointer",
              transition: "all 0.2s ease", width: "100%",
            }}
            onMouseEnter={(e) => {
              e.currentTarget.style.borderColor = "#1a1a1a";
              e.currentTarget.style.boxShadow = "0 2px 8px rgba(26,26,26,0.08)";
              e.currentTarget.style.transform = "translateY(-1px)";
            }}
            onMouseLeave={(e) => {
              e.currentTarget.style.borderColor = "#e5e5e5";
              e.currentTarget.style.boxShadow = "none";
              e.currentTarget.style.transform = "translateY(0)";
            }}
          >
            <div style={{
              width: "44px", height: "44px", flexShrink: 0,
              backgroundColor: "#f5f5f5", borderRadius: "10px",
              display: "flex", alignItems: "center", justifyContent: "center",
              color: "#1a1a1a",
            }}>
              {choice.icon}
            </div>
            <div>
              <div style={{ fontSize: "15px", fontWeight: "700", color: "#1a1a1a", marginBottom: "4px" }}>
                {choice.label}
              </div>
              <div style={{ fontSize: "14px", color: "#737373", lineHeight: "1.4" }}>
                {choice.description}
              </div>
            </div>
            <svg style={{ marginLeft: "auto", flexShrink: 0, alignSelf: "center", color: "#d1d5db" }}
              width="18" height="18" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2">
              <polyline points="9 18 15 12 9 6" />
            </svg>
          </button>
        ))}
      </div>
    </FormWrapper>
  );
}
